import Spline from "@splinetool/react-spline";
export default function Contact({ onLoad }) {
  return (
    <Spline
      style={{ height: "60vh" }}
      scene="https://prod.spline.design/5l2jAlaadoSqRTf4/scene.splinecode"
      onLoad={onLoad}
    />
  );
}
